
import React, { memo } from 'react';
import CountdownTimer from '@/components/CountdownTimer';
import LaunchButton from '@/components/LaunchButton';
import LLMLogos from '@/components/LLMLogosSection';
import { ShieldCheck } from 'lucide-react';

interface HeroSectionProps {
  onPricingClick: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = memo(({ onPricingClick }) => {
  return (
    <section className="py-16 md:py-24 px-4 hero-gradient">
      <div className="container mx-auto text-center">
        <CountdownTimer className="mb-6" />
        
        <h1 className="text-4xl md:text-6xl font-bold mb-6 max-w-4xl mx-auto leading-tight">
          <span className="gradient-text">20+ LLMs.</span> One subscription.
        </h1>
        
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-4">
          Access the latest AI models from OpenAI, Claude, Gemini, and more under one affordable plan.
        </p>

        <div className="flex items-center justify-center gap-2 mb-8 animate-fade-in">
          <ShieldCheck className="h-5 w-5 text-green-500" />
          <p className="text-green-600 font-medium">
            Try risk-free with our 7-day money-back guarantee
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mb-8">
          <LaunchButton variant="cta" size="lg" onClick={onPricingClick}>
            View Plans
          </LaunchButton>
        </div>
        
        <LLMLogos />
      </div>
    </section>
  );
});

HeroSection.displayName = 'HeroSection';

export default HeroSection;
